import React, { memo } from "react";
import { routes } from "../../routes/routes.constatns";
import { useDispatch } from "react-redux";
import {
  getEngagementById,
  setDefaultLoader,
  dropEngagementState
} from "../../store/slices/engagementSlice";
import { useNavigate } from "react-router-dom";
import { MotifChip } from '../../assets/lib/motif';

export default memo(({ node }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function onLinkClick(id) {
    let region_URL = "";
    let redirectFlag = false;
    dispatch(setDefaultLoader({ loader: false }));
    dispatch(dropEngagementState());
    // Bhushan - Removed this API call as this is duplicate in Header.jsx
    dispatch(getEngagementById({ id: id }));
    if (node.data.regionName === "United States") {
      region_URL = process.env.REACT_APP_URL_REG_US;
      redirectFlag = true;
    } else if (node.data.regionName === "Singapore") {
      region_URL = process.env.REACT_APP_URL_REG_APAC;
      redirectFlag = true;
    } else if (node.data.regionName === "Netherlands") {
      region_URL = process.env.REACT_APP_URL_REG_EU;
      redirectFlag = true;
    } else {
      region_URL = process.env.REACT_APP_URL_REG_ALL;
      redirectFlag = false;
    }

    window.location.href = `${region_URL}${routes.createNewEngagement}?regionId=${node.data.regionID}&engagementId=${node.data.id}`;
    // if (redirectFlag) {
    //   window.location.href = `${region_URL}${routes.createNewEngagement}?regionId=${node.data.regionID}&engagementId=${node.data.id}`;
    // } else {
    //   // Bhushan - Removed reload of page as this is not required
    //   // window.location.href = `${region_URL}${routes.createNewEngagement}?regionId=${node.data.regionID}&engagementId=${node.data.id}`;
    //   navigate(
    //     `/${routes.createNewEngagement}?regionId=${node.data.regionID}&engagementId=${node.data.id}`,
    //     { gestureEnabled: false }
    //   );
    // }
  }

  return (
    <>
      <span
        className={`view-engagement-link ${
          (node.data.activeFlag === 0) || (node?.data?.isSandboxEngagement && node?.data?.setupStepID !== 4) ? "view-engagement-link-inactive" : ""
        }`}
        onClick={() => {
          onLinkClick(node.data.id);
        }}
      >
        {node.data.engagementName}
      </span>
      {node?.data?.isSandboxEngagement && (
          <MotifChip
            label="Live"
            className="sandbox-engagement-chip"
          >
            Sandbox
          </MotifChip>
        )}
    </>
  );
});
